<template>
  <div class="event-label d-flex align-items-center text-center">
    <span :class="eventClass">{{ event }}</span>
  </div>
</template>

<script>
export default {
  name: 'EventLabel',
  props: {
    event: {
      required: true,
    },
  },
  computed: {
    eventClass() {
      return `event-label--${this.event}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.event-label{
    text-transform: uppercase;
    color: white;
    font-size: 0.65rem;
    border-radius: 1rem;
}
.event-label > span {
    border-radius: 4px;
    padding: 2px 5px 2px 5px;
}
.event-label--processed{
    background: $bg-edits;
}
.event-label--delivered{
    background: darken($bg-clients, 20%);
}
.event-label--open{
    background: darken($bg-dashboard, 20%);
}
.event-label--unsubscribed {
    background: #E9AD7D;
}
.event-label--bounced {
    background: #E9AD7D;
}
</style>
